<template>
  <section class="postingan">
    <div style="margin: 5em 0;min-height: 100vh;">
      <div class="container">

        <div class="card" v-for="(row, i) in postingan" :key="`postingan-${i}`">
          <div class="card-body p-5">
            <div class="row">
              <div class="col-md-4">
                <div v-if="row.thumbnail" :style="`height: 100%;background-size: cover;background-repeat: no-repeat;background-image: url(${row.thumbnail});`"></div>
                <div v-else style="height: 100%;background-color: #eee;" class="d-flex justify-content-center align-items-center">
                  <p style="font-weight: bold;color: #aaa;font-size: 1.75em;">No Images</p>
                </div>
              </div>
              <div class="col">
                <h4 class="mb-4">
                  <Link v-text="row.title" :href="`/${prefix}/${row.slug}`"></Link>
                </h4>
                <p class="text-muted">
                  <span v-text="(new Date(row.created_at)).toLocaleString()"></span>
                </p>
                <p v-text="row.shortext + '...'"></p>
                <a class="btn btn-outline-success" :href="`/${prefix}/${row.slug}`">Selengkapnya</a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>

<script>
import layout from '@/layout/Portal'
export default {
  layout,
  props: {
    postingan: String,
    prefix: String,
  }
}
</script>